import {Option} from "../../../domain/in/quote/option";
import {OptionSummary} from "../../../domain/out/option-summary";
import {PricingItemSummary} from "../../../domain/out/pricing-item-summary";
import {getAmountWithCurrency} from "../../../utils/string-utils";

export function getOptionsSummary(options: Option[], currency: string, locale: string): PricingItemSummary[] {
    return (options ?? []).map(option => {
        const pricingItemSummary = new PricingItemSummary();
        pricingItemSummary.option = new OptionSummary(
            option.label,
            option.quantity,
            option.precalculatedQuantity,
            getAmountWithCurrency(option.appliedPrice, currency, locale)
        );
        return pricingItemSummary;
    });
}
